import api from './axiosConfig';

export type ProductValidationSection = Record<string, unknown>;

export type ProductValidationTrendRow = {
  eventDateKst?: string;
  briefUsers?: number;
  watchlistSavers?: number;
  changeOpenUsers?: number;
  briefLoadErrorUsers?: number;
  [key: string]: unknown;
};

export type ProductValidationAnalyticsResponse = {
  measurementVersion?: string;
  todayKst?: string;
  days?: number;
  cohortDays?: number;
  summary?: ProductValidationSection;
  retention?: ProductValidationSection;
  quality?: ProductValidationSection;
  trend?: ProductValidationTrendRow[];
  gate?: ProductValidationSection;
  definitions?: Record<string, string>;
};

export async function getProductValidationAnalytics(
    days = 14,
    cohortDays = 28,
): Promise<ProductValidationAnalyticsResponse> {
  const response = await api.get<ProductValidationAnalyticsResponse>(
      '/analytics/admin/product-validation',
      {
        params: {days, cohortDays},
        withCredentials: true,
        timeout: 8_000,
      },
  );
  return response.data ?? {};
}
